import {FormProvider, useForm} from "react-hook-form";
import {CheckoutFormFormValues} from "../../../../../components/checkout-form/form/types";
import {yupResolver} from "@hookform/resolvers/yup";
import {Alert, Button, Col, Row, Space} from "antd";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {useCreateSessionContext} from "../../context/create-session";
import {useCreateService} from "../../hooks/create-service";
import {CreateSessionFormValues} from "../../reducers/create-session/types";
import {SessionCheckoutFormFields} from "../../../../../components/offering-form/session-bundle/session/checkout-form";
import {offeringCheckoutFormValidationSchema} from "../../../../../components/offering-form/general/checkout-form/validation-schema";
import {OfferingFormCheckoutFormValues} from "../../../../../components/offering-form/general/checkout-form/types";
import {useSyncCheckoutFormToContext} from "../../../../../utils/offering-create-draft";

export function CreateSessionCheckoutFormStep() {
  const {
    state: {formData, sessionData},
    dispatch,
  } = useCreateSessionContext();
  const checkoutFormMethods = useForm<OfferingFormCheckoutFormValues>({
    resolver: yupResolver(offeringCheckoutFormValidationSchema),
    mode: "onChange",
    defaultValues: formData,
  });
  useSyncCheckoutFormToContext({
    checkoutFormMethods,
    dispatch,
    saveActionType: "save-create-session-form-values",
    formData: {
      bookingQuestions: formData.bookingQuestions ?? [],
    },
  });
  const {createSession, isCreatingSession} = useCreateService();
  function onSubmit(values: CheckoutFormFormValues) {
    if (sessionData) {
      dispatch({
        type: "go-to-cover-images-upload-form-step",
        payload: {
          session: sessionData,
          formData: {...formData, ...values},
        },
      });
    } else {
      const payload: CreateSessionFormValues = {
        ...formData,
        ...values,
      };
      createSession(payload);
      // console.log({valuesMehn: values, payload});
    }
  }
  const isFormError = Object.keys(checkoutFormMethods.formState.errors).length > 0;
  const isBookingQuestionsError = checkoutFormMethods.formState.errors.bookingQuestions;
  return (
    <>
      <FormProvider {...checkoutFormMethods}>
        <form onSubmit={checkoutFormMethods.handleSubmit(onSubmit)} autoComplete="off">
          <Space size={16} direction="vertical" style={{display: "flex"}}>
            <SessionCheckoutFormFields
              isBookingQuestionsError={!!isBookingQuestionsError}
            />
            {isFormError && (
              <Alert
                message="Please fill in the required fields above, outlined in red"
                type="warning"
              />
            )}
            <Row gutter={[0, 16]}>
              <Col span={24} sm={12}>
                <StyledServiceButtonWrapper>
                  <Button
                    onClick={() =>
                      dispatch({
                        type: "go-to-basic-form-step",
                        payload: {
                          ...formData,
                          ...checkoutFormMethods.getValues(),
                        },
                      })
                    }
                    block
                    size="small"
                    type="default"
                  >
                    Back
                  </Button>
                  <Button
                    block
                    type="primary"
                    htmlType="submit"
                    size="small"
                    disabled={
                      Object.keys(checkoutFormMethods.formState.errors).length > 0 ||
                      Object.values(checkoutFormMethods.watch()).length < 1
                    }
                    loading={isCreatingSession}
                  >
                    Next
                  </Button>
                </StyledServiceButtonWrapper>
              </Col>
            </Row>
          </Space>
        </form>
      </FormProvider>
    </>
  );
}
